import { TAG_CODES } from "../../tag.config"

const GOM_POINT_DANGER_SOURCE = {
    type: 'triangle',
    tagCode: TAG_CODES.DEFAULT,
    withText: true,
    defaultText: 'Danger source',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'risk',
    withFillColor: true,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
}

export default GOM_POINT_DANGER_SOURCE